import { z } from 'zod';
import { notificationPreferencesSchema } from './notification';
import { deliveryPreferencesSchema } from './delivery';
import { returnsPreferencesSchema } from './returns';

export const preferencesDomainSchema = z.enum([
  'notification-preferences',
  'delivery-preferences',
  'returns',
]);

export type PreferenceDomainEnum = z.infer<typeof preferencesDomainSchema>;

export enum PreferenceDomain {
  Notification = 'notification-preferences',
  Delivery = 'delivery-preferences',
  Returns = 'returns',
}

export const preferencesSchema = z.object({
  [PreferenceDomain.Notification]: notificationPreferencesSchema.optional(),
  [PreferenceDomain.Delivery]: deliveryPreferencesSchema.optional(),
  [PreferenceDomain.Returns]: returnsPreferencesSchema.optional(),
});

export const updatePreferencesSchema = z.union([
  notificationPreferencesSchema,
  deliveryPreferencesSchema,
  returnsPreferencesSchema,
]);

export type UpdatePreferences = z.infer<typeof updatePreferencesSchema>;

export type Preferences = z.infer<typeof preferencesSchema>;
